import { tw } from '@/utils/tw';
import ContactEditorialTheme from 'base/components/ContactEditorial/theme';

const { Dialog, Button } = ContactEditorialTheme;

const TextArea = tw.theme({
  extend: ContactEditorialTheme.TextArea,
  defaultVariants: {
    variant: 'secondary',
  },
});

const TextField = tw.theme({
  extend: ContactEditorialTheme.TextField,
  defaultVariants: {
    variant: 'secondary',
  },
});

const Checkbox = tw.theme({
  extend: ContactEditorialTheme.Checkbox,
  slots: {
    label: ['items-start'],
  },
});

const ContactEditorial = tw.theme({
  extend: ContactEditorialTheme,
  slots: {
    base: ['bg-gray-50', 'md:wings', 'md:wings-gray-50'],
    headline: ['text-special-headline-sm', 'md:text-special-headline-lg', 'text-logga-600', 'mb-0'],
    caption: ['text-body-sm', 'sm:text-body-md'],
  },
});

export default Object.assign(ContactEditorial, { Button, TextField, TextArea, Checkbox, Dialog });
